import { doRequest } from "utils/core";

const pointAPI = {
  getPointList: (params) => {
    const url = "api/point/list";
    return doRequest("get", url, { params });
  },
};

export default pointAPI;
